import AuthService from '../../AuthService';
const news = {
  getNews(page){
    return AuthService.get(`/about/news?page=${page}`);
  },
  showNews(id){
    return AuthService.get(`/about/news/${id}`);
  },
  createNews(data){
    return AuthService.post(`/about/news`,data);
  },
  updateNews(id,data){
    return AuthService.put(`/about/news/${id}`,data);
  },
  deleteNews(id){
    return AuthService.delete(`/about/news/${id}`);
  },
}
export default news
